import script from "./PublicProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicProfile.vue?vue&type=script&setup=true&lang=js"

import "./PublicProfile.vue?vue&type=style&index=0&id=4eaae17f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eaae17f"]])

export default __exports__